const togglePopup = (id) => {
    let element = document.querySelectorAll(id)[0];
    let openClass = "c-popup--open";
    if (element && element.classList.contains(openClass)) {
        element.classList.remove(openClass);
        document.body.classList.remove("no-scroll");
    } else if (element) {
        element.classList.add(openClass);
        document.body.classList.add("no-scroll");
    }
}
const showLocation = (e) => {
    let id = e.currentTarget.dataset.target;
    document.querySelectorAll(".show-location").forEach((el) => el.classList.remove("show-location"));
    document.querySelectorAll(".action__item--active").forEach((el) => el.classList.remove("action__item--active"));
    e.currentTarget.classList.add("action__item--active");
    if (id) {
        let foundElements = document.querySelectorAll('[data-id="' + id + '"]');
        if (foundElements.length > 0) {
            foundElements[0].classList.add("show-location");
        }
    }
}

const buttons = document.querySelectorAll('.popup-toggle');
const closeButtons = document.querySelectorAll('.c-popup__toggle');
const checkBoxes = document.querySelectorAll('.action-checkbox');
const popUpBG = document.querySelectorAll('.c-popup__background');

buttons.length > 0 && buttons.forEach(button => button.addEventListener('click', () => togglePopup(".c-popup")));
closeButtons.length > 0 && closeButtons.forEach(button => button.addEventListener('click', () => togglePopup(".c-popup")));
checkBoxes.length > 0 && checkBoxes.forEach(checkBox => checkBox.addEventListener('click', (e) => showLocation(e)));
popUpBG.length > 0 && popUpBG.forEach(container => container.addEventListener('click', () => togglePopup(".c-popup")));

const popUpBody = document.querySelector('.c-popup__body')
if(popUpBody && popUpBody.classList.contains('c-popup__body--waterski')) {
    // const firstStep = document.getElementById('location');
    // firstStep.classList.add('d-none')
    checkBoxes[0].click()

    console.log('hoi')
}

/*
 Reserveren Pagina
 */
let selectedLocation = null;
let shownClasses = [];

const resetForm = () => {
    shownClasses.forEach((sc) => {
        document.querySelectorAll("." + sc).forEach((el) => el.classList.remove(sc));
    })
}

const filterArrangements = (e) => {
    let ids = e.currentTarget.dataset.options;
    let showClass = "show-arrangement";
    let activeClass = "c-booking__item--active";

    selectedLocation = e.currentTarget.dataset.id;

    //Reset classes on children
    resetForm();

    !shownClasses.includes(showClass) && shownClasses.push(showClass);

    document.querySelectorAll("." + showClass).forEach((el) => el.classList.remove(showClass));
    document.querySelectorAll("." + activeClass).forEach((el) => el.classList.remove(activeClass));
    e.currentTarget.classList.add(activeClass);
    if (ids) {
        ids.split(",").forEach((id) => {
            let foundElements = document.querySelectorAll('[data-id="' + id + '"]');

            if (foundElements.length > 0) {
                foundElements[0].parentElement.classList.add("body--has-children");
                foundElements.forEach((el) => {
                    el.classList.add(showClass);
                })
            }
        })
    }
}

const showFormForArrangement = (e) => {
    let currentArr = e.currentTarget.dataset.id;
    let formsFound = document.querySelectorAll("[data-loc='" + selectedLocation + "'][data-ar='" + currentArr + "']");
    let showClass = "show-form";
    let activeClass = "c-booking__item--active";
    let bodyActive = "body--has-children";

    !shownClasses.includes(showClass) && shownClasses.push(showClass);
    !shownClasses.includes(bodyActive) && shownClasses.push(bodyActive);

    if (formsFound.length === 1) {
        document.querySelectorAll("." + showClass).forEach((el) => el.classList.remove(showClass));
        formsFound[0].classList.add(showClass);
        formsFound[0].parentElement.classList.add(bodyActive);
        document.querySelectorAll(".show-arrangement." + activeClass).forEach((el) => el.classList.remove(activeClass));
        e.currentTarget.classList.add(activeClass);
    } else {
        console.log("Error while looking for forms, no forms found for location with arrangement");
    }
}

const resCheckBox = document.querySelectorAll('.c-booking__item--location');
const arrangementBox = document.querySelectorAll('.c-booking__item--arrangement');

resCheckBox.length > 0 && resCheckBox.forEach(checkbox => checkbox.addEventListener('click', (e) => filterArrangements(e)));
arrangementBox.length > 0 && arrangementBox.forEach(checkbox => checkbox.addEventListener('click', (e) => showFormForArrangement(e)));


const resWrapper = document.querySelector('.c-booking')
if(resWrapper && resWrapper.classList.contains('c-booking--waterski')) {
    const firstStep = document.getElementById('location');
    firstStep.classList.add('d-none')
    resCheckBox[0].click()
}